<template>
  <div class="t-progress-circle"
    :style="`
      width: ${diameter}px;
      height: ${diameter}px;
    `"
    >
    <canvas
      ref="t-progress-circle"
      :width="diameter * 2"
      :height="diameter * 2"
      :style="`
        width: ${diameter}px;
        height: ${diameter}px;
      `"
      >
    </canvas>
    <!-- v-if="(!show_values || data.segments[index].value || data.segments[index].count && data.segments[index].count > 0) && !isSvgIcon(segment.icon)" -->
    <template v-for="(segment, index) in data.segments">
<!-- CAREFUL: Performance when usage with v-icons and svg-icons. If so add '&& isSvgIcon(segment.icon)' to v-if="..." at line 34- -->
      <v-icon
        v-if="(!show_values || data.segments[index].value || data.segments[index].count && data.segments[index].count > 0) && !isSvgIcon(segment.icon)"
        :key="index"
        class="t-progress-circle-icon"
        :color="color === '0,0,0'?'black':'white'"
        :style="`
          transform: rotate(${getRotate(index)}deg) translate(calc(${diameter / 2}px + 6px + 1px)) rotate(${getRotate(index) * -1}deg);
          ${show_icons?'opacity: 1':''}
        `"
        >
        {{segment.icon}}
      </v-icon>
      <svg-icon
        v-else-if="(!show_values || data.segments[index].value || data.segments[index].count && data.segments[index].count > 0) && isSvgIcon(segment.icon)"
        :key="index"
        class="t-progress-circle-icon"
        :color="color === '0,0,0'?'black':'white'"
        :style="`
          transform: rotate(${getRotate(index)}deg) translate(calc(${diameter / 2}px + 6px + 1px)) rotate(${getRotate(index) * -1}deg);
          ${show_icons?'opacity: 1':''}
        `"
        :name="segment.icon"
      />
    </template>
    <div
      class="t-progress-circle-text"
      :style="show_values?'opacity: 0':''"
      >
      <div >{{parseInt(data.percentage)}}%</div>
    </div>
    <div
      class="t-progress-circle-text"
      :style="!show_values?'opacity: 0':''"
      >
      <div>{{parseInt(data.total)}}</div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    props: ['diameter', 'width', 'color', 'data', 'show_icons', 'show_values'],
    data: () => ({
    }),
    computed: {
      ...mapGetters('View', [
        'isSvgIcon'
      ]),
      segment_degs() {
        let segment_degs = [];
        if (this.show_values) {
          this.data.segments.forEach(segment => {
            segment_degs.push((360 / this.data.total) * segment.count)
          });
          if (this.data.total === 0) {
            segment_degs.splice(0, 1, 360)
          }
          return segment_degs;
        } else {
          this.data.segments.forEach(() => {
            segment_degs.push(360 / this.data.segments.length);
          });
          return segment_degs;
        }
      }
    },
    mounted() {
      this.drawCircle(false)
    },
    updated() {
      this.drawCircle(true)
    },
    methods: {
      getRotate(index) {
        let deg = -90;
        for (var i = 0; i < index; i++) {
          deg = deg + this.segment_degs[i];
        }
        deg = deg + (this.segment_degs[index] / 2);
        return deg;
      },
      drawCircle(update) {
        let canvas = this.$refs['t-progress-circle'];
        if (canvas) {
          var ctx = canvas.getContext('2d');
          //clear for redraw
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          //params
          let factor = Math.PI / 180;
          let radius = (this.diameter - this.width) / 2
          if (!update) {
            ctx.scale(2,2);
          }
          ctx.lineWidth = this.width;
          //draw
          let start_deg = 0;
          let end_deg = -92;
          this.data.segments.forEach((segment, index) => {
            // let start_deg = index * this.segment_deg - 88
            // let end_deg = (index + 1) * this.segment_deg - 92
            start_deg = end_deg + 4;
            end_deg = start_deg + this.segment_degs[index] - 4
            ctx.beginPath();
            ctx.arc(18, 18, radius, factor * start_deg, factor * end_deg, false);
            ctx.strokeStyle = `rgba(${this.color},${segment.value?this.color === '0,0,0'?'0.8':'0.9':'0.1'})`
            ctx.stroke()
          });
        }
      }
    }
  }
</script>
<style>
  .t-progress-circle {
    position: relative;
    overflow: visible;
  }
  .t-progress-circle-icon {
    position: absolute !important;
    font-size: 12px !important;
    margin-left: -6px;
    margin-top: -6px;
    left: 50%;
    top: 50%;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  .t-progress-circle-text {
    position: absolute;
    font-size: 10px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }

</style>
